 //Cart Drawer start

 var cartDrawer = document.querySelector('cartDrawer');
 function cartDrawerOpenClose(action) {
   var targetDrawer = document.querySelector('cartDrawer');
   if (action == 'open') {
     targetDrawer.classList.add('is-open');
     targetDrawer.setAttribute('aria-hidden', 'false');
     targetDrawer.setAttribute('tabindex', '0');
     document.body.style.overflow = 'hidden';
   } else if (action == 'close') {
     targetDrawer.classList.remove('is-open');
     document.body.style.overflow = '';
     targetDrawer.setAttribute('aria-hidden', 'true');
     targetDrawer.setAttribute('tabindex', '-1');
   }
 }
 cartDrawer.querySelector('.overlay').addEventListener('click', () => {
   cartDrawerOpenClose('close');
 });

 var cartTargetIconAll = document.querySelectorAll('.cart-target-icon');
 cartTargetIconAll.forEach((cartTargetIcon) => {
   cartTargetIcon.addEventListener('click', (e) => {
     cartDrawerOpenClose('open');
   });
 });
 if (!customElements.get('cart-drawer-close')) {
  customElements.define(
    'cart-drawer-close',
    class CartDrawerClose extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', () => {
          cartDrawerOpenClose('close');
        });
      }
    }
  );
}

